import React, { useState, useEffect } from "react";
import DataTable from "../components/DataTable";
import SnackbarAlert from "../components/SnackbarAlert";
import { Box, TextField, Tooltip, Typography, Button, CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { webEndPoint } from '../constants/globalConstants';
import { makeRequest } from "../services/api";
export default function Coupon() {
    const [datasource, setDatasource] = useState([]);
    const [search, setSearch] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [editState, setEditState] = useState(null);
    const [couponCode, setCouponCode] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [discountAmount, setDiscountAmount] = useState("");
    const [snackbar, setSnackbar] = useState(false);
    const [message, setMessage] = useState("");
    const today = new Date().toISOString().split("T")[0];
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        fetchages();
    }, []);
    const fetchages = async () => {
        setLoading(true);
        try {
            let url = webEndPoint + "coupon";
            const response = await makeRequest("get", url);
            if (response) {
                setDatasource(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const openAddModal = () => {
        setEditState(null);
        setCouponCode("");
        setStartDate("");
        setEndDate("");
        setDiscountAmount("");
        setOpenModal(true);
    };
    const handleEdit = (state) => {
        setEditState(state);
        setCouponCode(state?.coupon_code);
        setStartDate(state?.start_date ? state.start_date.split("T")[0] : "");
        setEndDate(state?.end_date ? state.end_date.split("T")[0] : "");
        setDiscountAmount(state?.discount_value);
        setOpenModal(true);
    };
    const handleClose = () => {
        setOpenModal(false);
        setCouponCode("");
    };
    const handleSave = async () => {
        if (!couponCode.trim() && !startDate && !endDate) {
            setMessage("Coupon Code, Start Date , End Date are Required");
            setSnackbar(true);
            return;
        }
        setLoading(true);
        try {
            if (editState) {
                const couponEditData = {
                    coupon_code: couponCode,
                    description: "",
                    discount_type: "fixed",
                    discount_value: discountAmount,
                    min_order_amount: 1,
                    max_discount_amount: 10000,
                    usage_limit: 10000,
                    start_date: startDate,
                    end_date: endDate,
                    isActive: 0
                };
                try {
                    let url = webEndPoint + "coupon/" + editState.rfId;
                    const response = await makeRequest("put", url, couponEditData);
                    if (response) {
                        setLoading(false);
                        setMessage("Coupon Updated Successfully");
                    }
                } catch (err) {
                    if (err?.message) {
                        setMessage(err.message);
                    } else {
                        setMessage("Something went wrong");
                    }
                } finally {
                    setLoading(false);
                }
            } else {
                const ageAddData = {
                    coupon_code: couponCode,
                    description: "",
                    discount_type: "fixed",
                    discount_value: discountAmount,
                    min_order_amount: 1,
                    max_discount_amount: 10000,
                    usage_limit: 10000,
                    start_date: startDate,
                    end_date: endDate,
                    isActive: 0
                };
                try {
                    let url = webEndPoint + "coupon";
                    const response = await makeRequest("post", url, ageAddData);
                    if (response) {
                        setLoading(false);
                        setMessage("Coupon Added Successfully");
                    }
                } catch (err) {
                    if (err?.message) {
                        setMessage(err.message);
                    } else {
                        setMessage("Something went wrong");
                    }
                } finally {
                    setLoading(false);
                }
            }
            fetchages();
            setSnackbar(true);
            setOpenModal(false);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
};
    const filteredState = datasource?.filter((d) =>
        d?.coupon_code?.toLowerCase().includes(search?.toLowerCase())
    );
    const columns = ["S.No", "Coupon Code", "Start Date", "End Date", "Discount Amount", "Action"];
    const rows = filteredState?.map((district, index) => [index + 1, district.coupon_code,formatDate(district.start_date),formatDate(district.end_date), district.discount_value,
    <Box>
        <Tooltip title="Edit Coupon">
            <Button variant="contained" color="primary" onClick={() => handleEdit(district)}>Edit</Button>
        </Tooltip>
    </Box>
    ]);
    return (
        <Box sx={{ position: "relative" }}>
            {loading && (
                <Box sx={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", backgroundColor: "rgba(255,255,255,0.6)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999, }}>
                    <CircularProgress />
                </Box>
            )}
            <Typography variant="h6" sx={{ mb: 3, fontWeight: 500 }}>Coupon</Typography>
            <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 2, alignItems: { xs: "stretch", sm: "center" }, justifyContent: "space-between", mb: 2, width: "100%", }}>
                <TextField label="Search Coupon" size="small" value={search} onChange={(e) => setSearch(e.target.value)} sx={{ width: { xs: "100%", sm: "70%", md: 600 } }} />
                <Button variant="contained" startIcon={<AddIcon />} onClick={openAddModal} sx={{ width: { xs: "100%", sm: "auto" }, }}>Add Coupon Code</Button>
            </Box>
            <DataTable columns={columns} rows={rows} />
            <SnackbarAlert open={snackbar} setOpen={setSnackbar} message={message} />
            <Dialog open={openModal} onClose={handleClose} fullWidth maxWidth="sm">
                <DialogTitle> {editState ? "Edit Coupon" : "Add Coupon"}</DialogTitle>
                <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
                    <TextField label="Coupon" value={couponCode} onChange={(e) => setCouponCode(e.target.value)} sx={{ mt: 2 }} fullWidth />
                    <TextField label="Start Date" type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} InputLabelProps={{ shrink: true }} inputProps={{ min: today }} fullWidth />
                    <TextField label="End Date" type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} InputLabelProps={{ shrink: true }} fullWidth />
                    <TextField label="Discount Amount" type="number" value={discountAmount} onChange={(e) => setDiscountAmount(e.target.value)} fullWidth />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button variant="contained" onClick={handleSave}>Save</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}